<template>
	<div class="main" v-if="loaded">
		<section>
			<header class="page-title">
				<h2>{{provider.name}} - Pricing</h2>
				<div class="ml-auto">
					<a @click.prevent="showModal(null,'create')" class="btn btn-md btn-success" href="#"><i class="fas fa-plus"></i> Add New Price</a>
				</div>
			</header>
			<div class="table-responsive">
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Name</th>
							<th>Price</th>
							<th>Actions</th>
						</tr>
					</thead>
					<draggable :element="'tbody'" :list="providerActivePrices" @end="drag=false" @start="drag=true" @update="onUpdate">
						<tr class="draggable" v-for="(providerPrice,index) in providerActivePrices">
							<td class="text-center"><i class="fas fa-grip-lines"></i></td>
							<td>{{providerPrice.name}}</td>
							<td>${{providerPrice.price}}
								<span class="badge badge-warning" v-if="providerPrice.is_special_offer">Special Offer - {{providerPrice.special_offer_percentage}}%</span>
								<span v-if="providerPrice.is_special_offer">{{providerPrice.special_offer_text}}</span>
								<span class="badge badge-danger" v-if="currentDate < providerPrice.special_offer_start_date">Active from: {{providerPrice.special_offer_start_date}}</span>
								<span class="badge badge-danger" v-if="providerPrice.is_special_offer && providerPrice.special_offer_end_date.length !== 0 && currentDate > providerPrice.special_offer_end_date">EXPIRED: {{providerPrice.special_offer_end_date}}</span>
							</td>
							<td class="nowrap">
								<a @click.prevent="showModal(index,'edit')" class="btn btn-icon btn-primary" href="#" v-if="!providerPrice.is_special_offer"><i class="fas fa-fw fa-pen" title="Edit"></i></a>
								<a @click.prevent="showModal(index,'offer-edit')" class="btn btn-icon btn-primary" href="#" v-if="providerPrice.is_special_offer"><i class="fas fa-fw fa-pen" title="Edit"></i></a>
								<a @click.prevent="removeProviderPrice(providerPrice.id)" class="btn btn-icon btn-danger" href="#"><i class="fas fa-fw fa-times" title="Delete"></i></a>
							</td>
						</tr>
					</draggable>
				</table>
			</div>
		</section>

		<section class="mt-4">
			<header class="page-title">
				<h2>Old Prices</h2>
			</header>
			<div class="table-responsive">
				<table>
					<thead>
						<tr>
							<th>Name</th>
							<th>Price</th>
							<th>Removed</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="providerPrice in providerInactivePrices">
							<td>{{providerPrice.name}}</td>
							<td>${{providerPrice.price}}
								<span class="badge badge-default" v-if="providerPrice.is_special_offer">Special Offer - {{providerPrice.special_offer_percentage}}%</span>
								<span v-if="providerPrice.is_special_offer">{{providerPrice.special_offer_text}}</span>
							</td>
							<td>{{providerPrice.updated_at}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>

		<div class="modal-bg" v-if="isModalVisible">
			<div class="modal">
				<header class="modal-header">
					<h4 class="modal-title">New Price</h4>
					<a @click.prevent="closeModal" class="modal-close" title="Close modal"><i class="fas fa-times"></i></a>
				</header>

				<section class="modal-body">
					<div class="switches large mb-2">
						<input class="switch-primary" id="normalprice" name="price-type" type="radio" v-model="selectedItems.type" value="normalprice">
						<label class="label-checkbox" for="normalprice">Normal Price</label>
						<input class="switch-primary" id="specialoffer" name="price-type" type="radio" v-model="selectedItems.type" value="specialoffer">
						<label class="label-checkbox" for="specialoffer">Special Offer</label>
					</div>
					<div class="card">
						<header class="card-header language-list">
							<lang-selector></lang-selector>
						</header>
						<div class="card-body">
							<div class="form-group">
								<label for="name">Name</label>
								<input @keypress="canEdit" id="name" name="name" type="text" v-model="providerPrice.translations[activeLanguage].name" :disabled="userRoles.includes('users.translator') && activeLanguage === defaultLocale">
								<p class="input-error" v-if="errors.errors[errorNameCurrentLanguage]">{{ errors.errors[errorNameCurrentLanguage] }}</p>
							</div>
							<div class="form-group">
								<label for="price_explanatory">Explanatory text (eg. paid 40$ annually)</label>
								<input @keypress="canEdit" id="price_explanatory" name="price_explanatory" type="text" v-model="providerPrice.translations[activeLanguage].price_explanatory" :disabled="userRoles.includes('users.translator') && activeLanguage === defaultLocale">
							</div>
							<div class="form-group" v-show="selectedItems.type === 'specialoffer'">
								<label for="special_offer_text">Special Promo Text</label>
								<input @keypress="canEdit" id="special_offer_text" name="special_offer_text" type="text" v-model="providerPrice.translations[activeLanguage].special_offer_text" :disabled="userRoles.includes('users.translator') && activeLanguage === defaultLocale">
								<p class="input-error" v-if="errors.errors[errorSpecialOfferTextCurrentLanguage]">{{ errors.errors[errorSpecialOfferTextCurrentLanguage] }}</p>
							</div>
						</div>
					</div>
					<div class="flex" v-show="selectedItems.type === 'normalprice'">
						<div class="form-group mb-0">
							<label>Type</label>
							<div class="switches large">
								<input class="switch-primary" id="normalpaid" name="normal-piad" type="radio" v-model="selectedItems.normalPlan" value="normalpaid">
								<label class="label-checkbox" for="normalpaid">Paid</label>
								<input class="switch-primary" id="normalfree" name="normal-free" type="radio" v-model="selectedItems.normalPlan" v-on:change="normalOfferPlan" value="normalfree">
								<label class="label-checkbox" for="normalfree">Free</label>
							</div>
						</div>
						<div class="form-group flex-1 ml-1">
							<label for="price">Unit price ($)</label>
							<input @keypress="canEdit" :disabled="selectedItems.normalPlan === 'normalfree' || userRoles.includes('users.translator')" id="price" name="price" type="text" v-model="providerPrice.price">
							<p class="input-error" v-if="errors.errors.price">{{ errors.errors.price }}</p>
						</div>
					</div>

					<div class="flex box mb-2" v-show="selectedItems.type === 'specialoffer'">
						<div class="six-lg">
							<div class="flex">
								<div class="form-group mb-0">
									<label>Type</label>
									<div class="switches large">
										<input class="switch-primary" id="specialpaid" name="special-paid" type="radio" v-model="selectedItems.specialPlan" value="specialpaid">
										<label class="label-checkbox" for="specialpaid">Paid</label>
										<input class="switch-primary" id="specialfree" name="special-free" type="radio" v-model="selectedItems.specialPlan" v-on:change="specialOfferPlan" value="specialfree">
										<label class="label-checkbox" for="specialfree">Free</label>
									</div>
								</div>
								<div class="form-group flex-1 ml-1">
									<label for="special_offer_price">Special Offer Price ($)</label>
									<input @keypress="canEdit" :disabled="selectedItems.specialPlan === 'specialfree' || userRoles.includes('users.translator')" id="special_offer_price" name="special_offer_price" type="text" v-model="providerPrice.special_offer_price">
									<p class="input-error" v-if="errors.errors.special_offer_price">{{ errors.errors.special_offer_price }}</p>
								</div>
							</div>
						</div>
						<div class="six-lg" v-show="selectedItems.type === 'specialoffer'">
							<div class="form-group">
								<label for="special_offer_last_price">Normal Price (Strokethrough)</label>
								<input @keypress="canEdit" id="special_offer_last_price" name="special_offer_last_price" type="text" v-model="providerPrice.special_offer_last_price" :disabled="userRoles.includes('users.translator')">
								<p class="input-error" v-if="errors.errors.special_offer_last_price">{{ errors.errors.special_offer_last_price }}</p>
							</div>
						</div>
					</div>
					<div class="flex box start" v-show="selectedItems.type === 'specialoffer'">
						<div class="form-group six-lg">
							<label for="special_offer_start_date">Special Offer Start Date</label>
							<input @keypress="canEdit" id="special_offer_start_date" name="special_offer_start_date" type="date" v-model="providerPrice.special_offer_start_date" :disabled="userRoles.includes('users.translator')">
							<p class="input-error" v-if="errors.errors.special_offer_start_date">{{ errors.errors.special_offer_start_date }}</p>
						</div>
						<div class="form-group six-lg">
							<label for="special_offer_end_date">Special Offer End Date</label>
							<input @keypress="canEdit" id="special_offer_end_date" name="special_offer_end_date" type="date" v-model="providerPrice.special_offer_end_date" :disabled="userRoles.includes('users.translator')">
							<p class="input-error" v-if="errors.errors.special_offer_end_date">{{ errors.errors.special_offer_end_date }}</p>
						</div>
						<div class="form-group flex-1 ml-1 text-center">
							<p>(If you don't fill these, the promotion will stay active until removed)</p>
						</div>
					</div>

				</section>
				<footer class="modal-footer">
					<a @click.prevent="closeModal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
					<a @click.prevent="updateProviderPrice" class="btn btn-md btn-success" href="#"><i class="fas fa-check"></i> Save Price</a>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
	import Errors from '../../Utils/Errors.js';
	import draggable from 'vuedraggable';
	import {eventBus} from "../../app";

	export default {
		component: {
			draggable,
		},
		props: {
			providerid: {
				type: Number
			},
			dataCurrentDate: {
				type: String
			}
		},
		data() {
			return {
				tabName: 'providerPricing',
				providerId: this.providerid,
				loaded: false,
				provider: {},
				providerActivePrices: {},
				providerInactivePrices: {},

				isModalVisible: false,
				selectedItems: {
					type: "normalprice",
					normalPlan: "normalpaid",
					specialPlan: "specialpaid",
				},
				providerPrice: {
					provider_id: this.providerId,
					name: null,
					price: 0,
					is_active: true,
					special_offer_text: null,
					price_explanatory: null,
					special_offer_price: null,
					special_offer_start_date: null,
					special_offer_end_date: null,
					special_offer_last_price: null
				},
				currentDate: '',
				activeLanguage: 'en',
				defaultLocale: this.$defaultLanguage.locale,
				userRoles: this.$currentUserRoles,

				errors: new Errors()
			}
		},
		created() {
			this.fetchDataFromApi();
			let vm = this;
			eventBus.$on('setActiveStatus', function (locale) {
				vm.activeLanguage = locale;
			});
		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/fetchtabdata/' + vm.providerId, {
					tab: vm.tabName
				})
						.then(response => {
							if (response.data.hasOwnProperty('provider')) {
								vm.provider = response.data.provider;
							}
							if (response.data.hasOwnProperty('providerActivePrices')) {
								vm.providerActivePrices = response.data.providerActivePrices;
							}
							if (response.data.hasOwnProperty('providerInactivePrices')) {
								vm.providerInactivePrices = response.data.providerInactivePrices;
							}
							if (response.data.hasOwnProperty('currentDate')) {
								vm.currentDate = response.data.currentDate;
							}
							vm.loaded = true;
						})
						.catch(e => {
							vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
						});
			},
			specialOfferPlan: function () {
				this.providerPrice.special_offer_price = "0";
			},
			normalOfferPlan: function () {
				this.providerPrice.price = 0;
			},
			showModal: function (index, action) {
				this.activeLanguage = 'en';
				if (index !== null && action !== 'create') {
					this.providerPrice = this.providerActivePrices[index];

					if (this.providerPrice.price === '0') {
						this.selectedItems.normalPlan = 'normalfree';
						this.selectedItems.specialPlan = 'specialfree';
						this.providerPrice.special_offer_price = "0";
					} // if

					if (action === 'offer-edit') {
						this.providerPrice.special_offer_price = this.providerPrice.price;
						this.selectedItems.type = 'specialoffer';
					} // if
				} // if

				if (typeof this.providerPrice.translations === 'undefined') {
					this.providerPrice.translations = {};
				}
				for (let i = 0; i < this.$availableLanguages.length; i++) {
					let locale = this.$availableLanguages[i].locale;
					if (typeof this.providerPrice.translations[locale] === 'undefined') {
						this.providerPrice.translations[locale] = {};
						this.providerPrice.translations[locale]['name'] = null;
						this.providerPrice.translations[locale]['special_offer_text'] = null;
						this.providerPrice.translations[locale]['price_explanatory'] = null;
					}
				}
				this.isModalVisible = true;
			},
			closeModal: function () {
				this.selectedItems = {
					type: "normalprice",
					normalPlan: "normalpaid",
					specialPlan: "specialpaid",
				};
				this.providerPrice = {
					provider_id: this.provider.id,
					name: null,
					price: 0,
					is_active: true,
					special_offer_text: null,
					price_explanatory: null,
					special_offer_price: null,
					special_offer_start_date: null,
					special_offer_end_date: null,
					special_offer_last_price: null
				};
				this.errors = new Errors();
				this.isModalVisible = false;
			},
			onUpdate: function () {
				axios.post('/api/' + this.$selectedSite.slug + '/provider-price-order/', this.providerActivePrices)
						.then(response => {
							this.$toastr.success('Provider Price order saved successfully.');
						})
						.catch(e => {
							this.errors.record(e.response.data);
							this.$toastr.error('Save Provider Price order failed.', 'Error');
						});
			},
			updateProviderPrice: function () {
				this.providerPrice.provider_id = this.provider.id;
				if (this.providerPrice.id) {
					if (this.selectedItems.type === "normalprice") {
						this.providerPrice.special_offer_price = null;
						this.providerPrice.special_offer_text = null;
						this.providerPrice.special_offer_start_date = null;
						this.providerPrice.special_offer_end_date = null;
						this.providerPrice.special_offer_last_price = null;
					} // if

					axios.put('/api/' + this.$selectedSite.slug + '/providers/provider-price/' + this.providerPrice.id, this.providerPrice)
							.then(response => {
								if (response.data.success) {
									this.$toastr.success('Provider Price saved successfully', 'Success');
									window.location.reload();
								} else {
									this.$toastr.error(response.data.failed, 'Error');
								} // if
							})
							.catch(e => {
								this.errors.record(e.response.data);
								this.$toastr.error('Provider Price save failed.', 'Error');
							});
				} else {
					axios.post('/api/' + this.$selectedSite.slug + '/providers/provider-price/', this.providerPrice)
							.then(response => {
								this.$toastr.success('Provider Price added successfully.');
								window.location.reload();
							})
							.catch(e => {
								this.errors.record(e.response.data);
								this.$toastr.error('Save new Provider Price failed.', 'Error');
							});
				}
			},
			removeProviderPrice: function (id) {
				let vm = this;
				vm.$dialog.confirm('Are you sure you want to remove this Price from the List?')
						.then((dialog) => {
							axios.delete('/api/' + vm.$selectedSite.slug + '/providers/provider-price/' + id)
									.then(response => {
										vm.$toastr.success('Delete successful.');
										location.reload();
									})
									.catch(errors => {
										dialog.close();
										vm.$toastr.error('Delete failed.');
									});
						})
						.catch(error => {
							vm.$toastr.error('Delete aborted.');
						});
			},
			canEdit: function (event) {
				let vm = this;
				if(vm.userRoles.includes('users.translator') && vm.clickedLang === vm.defaultLocale) {
					event.preventDefault();
					event.stopPropagation();
				}
			}
		},
		computed: {
			errorNameCurrentLanguage: function () {
				return 'translations_' + this.activeLanguage + '_name';
			},
			errorSpecialOfferTextCurrentLanguage: function () {
				return 'translations_' + this.activeLanguage + '_special_offer_text';
			},
		}
	}
</script>

<style scoped>

</style>
